import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {urlApi} from 'src/environments/environment';

type httpOptions = { headers: any; params: any };

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  private baseUrl = urlApi;
  constructor(private http: HttpClient) {}

  public async get(url: string, options: httpOptions): Promise<any> {
    try {
      const finalUrl = this.baseUrl + url;
      return await this.http.get(finalUrl, options).toPromise();
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  public async post(url: string, body: object, options: httpOptions): Promise<any> {
    try {
      const finalUrl = this.baseUrl + url;
      return await this.http.post(finalUrl, body, options).toPromise();
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  public async put(url: string, body: object, options: httpOptions): Promise<any> {
    try {
      const finalUrl = this.baseUrl + url;
      return await this.http.put(finalUrl, body, options).toPromise();
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  public async patch(url: string, body: object, options: httpOptions): Promise<any> {
    try {
      const finalUrl = this.baseUrl + url;
      return await this.http.patch(finalUrl, body, options).toPromise();
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  public async delete(url: string, options: httpOptions): Promise<any> {
    try {
      const finalUrl = this.baseUrl + url;
      return await this.http.delete(finalUrl, options).toPromise();
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}
